<mat-card class="example-card">
  <mat-card-header class="py-8 bg-blue-900 text-white flex rounded-t-md">
    <div class="font-bold text-3xl">Fournisseur</div>
  </mat-card-header>
  <mat-card-content class="border">
    <!------------ bare de chargement ----------------->

    <div *ngIf="exist; else attente"></div>
    <ng-template #attente>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>

    <div class="flex item-center justify-between w-full">
      <div class="flex flex-row items-center justify-between my-4">
        <mat-form-field appearance="outline" class="width-150 mx-2">
          <mat-label
            style="
              font-weight: bold;
              font-size: 25px;
              margin-left: 0;
              padding-right: 17px;
            "
            >Prestation</mat-label
          >
          <mat-select
            (selectionChange)="changeMainSelectPrestation($event.value)"
            name="TravelD_TypeEvent"
            [(ngModel)]="typeEvent"
            placeholder="Prestation"
          >
            <mat-option
              *ngFor="let t of listeTypeEvennement"
              [value]="t.TravelD_TypeEvent"
              >{{ t.text }}</mat-option
            >
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="width-150 mx-2">
          <mat-label
            style="
              font-weight: bold;
              font-size: 25px;
              margin-left: 0;
              padding-right: 17px;
            "
            >Ville</mat-label
          >
          <mat-select
            (selectionChange)="changeMainSelectville($event.value)"
            name="TravelD_ville"
            [(ngModel)]="ville"
            placeholder="Ville"
          >
            <mat-option
              *ngFor="let ville of listVilles"
              [value]="ville.Ville"
              >{{ ville.Ville }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <button
        [disabled]="!exist"
        (click)="getAllListFournisseur(); init()"
        mat-raised-button
        class="colorGreen max-h-12 bg-blue-700 mx-8 my-8 text-lg w-full"
      >
        <mat-icon>info</mat-icon>
        voir tous les fournisseurs
      </button>

      <div class="flex my-8 ml-2 w-full">
        <input
          type="text"
          [(ngModel)]="dsVille?.Villes[0].Ville"
          class="py-1 px-4 border-b border-gray-300 focus:outline-none focus:border-blue-300 w-full placeholder-gray-500"
          placeholder="Entrer le nom de la ville"
        />
        <button
          (click)="addVille()"
          class="py-2 px-3 bg-blue-500 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700"
        >
          <i class="fas fa-plus"></i>
        </button>
      </div>
    </div>

    <br />
    <app-liste
      *ngIf="columnsFournisseur"
      [listBtn]="listBtn"
      #listeConmponent
      [showFilter]="true"
      [showSort]="true"
      [showHeader]="false"
      [maxHeight]="200"
      [titre]="'<h4><b>Fournisseur trouvées</b></h4>'"
      [dataSource]="listeFournisseurs"
      [columns]="columnsFournisseur"
      (output)="output($event)"
    >
    </app-liste>
    <br />
  </mat-card-content>
</mat-card>

<ng-template #frmAjout>
  <div class="display-flex-end mb-20 gap-4 space-x-2">
    <button
      mat-raised-button
      class="colorGreen"
      (click)="ajouterOuModifierLigneFournisseur()"
    >
      <mat-icon>done</mat-icon>
      Enregistrer
    </button>

    <button (click)="close()" mat-raised-button class="bg-red-600 text-white">
      <mat-icon>close</mat-icon>
      Fermer
    </button>
  </div>

  <form action="">
    <div class="flex flex-row justify-between">
      <mat-form-field appearance="outline" class="width-150 mx-2">
        <mat-label
          style="
            font-weight: bold;
            font-size: 25px;
            margin-left: 0;
            padding-right: 17px;
          "
          >Prestation</mat-label
        >
        <input
          type="text"
          matInput
          placeholder="entrez nom de prestation"
          [matAutocomplete]="auto1"
          [formControl]="prestationCtrl"
        />
        <mat-autocomplete
          #auto1="matAutocomplete"
          [displayWith]="displayFn"
          (optionSelected)="typeEvennementChange($event.option.value)"
        >
          <mat-option
            *ngFor="let pres of filteredPrestation | async"
            [value]="pres"
          >
            {{ pres.text }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field appearance="outline" class="width-150 mx-2">
        <mat-label
          style="
            font-weight: bold;
            font-size: 25px;
            margin-left: 0;
            padding-right: 17px;
          "
          >Ville</mat-label
        >
        <input
          type="text"
          matInput
          placeholder="entrez nom de ville"
          [matAutocomplete]="auto2"
          [formControl]="stateCtrl"
        />
        <mat-autocomplete
          #auto2="matAutocomplete"
          (optionSelected)="typeVilleChange($event.option.value)"
        >
          <mat-option
            *ngFor="let ville of filteredStates | async"
            [value]="ville.Ville"
          >
            {{ ville.Ville }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <!-- info message -->
    <div
      *ngIf="info_message"
      class="flex bg-blue-100 rounded-lg p-4 mb-4 text-lg text-blue-700"
    >
      <svg
        class="inline mr-3"
        style="width: 25px; height: 25px"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
          clip-rule="evenodd"
        ></path>
      </svg>
      <div>
        {{ info_message }}
      </div>
    </div>

    <div class="flex flex-col">
      <mat-form-field
        appearance="outline"
        style="width: 100%; font-weight: bold; font-size: 25px"
        class="mx-2"
      >
        <mat-label
          style="
            font-weight: bold;
            font-size: 25px;
            margin-left: 0;
            padding-right: 17px;
          "
          >Code fournisseur</mat-label
        >
        <input
          type="text"
          matInput
          name="code_four"
          [(ngModel)]="dsFournisseur.Tiers[0].Tiers_code"
          (input)="check_TiersCode_validity(prefix_TiersCode)"
          placeholder="code fournisseur"
        />
      </mat-form-field>
      <!-- alert message -->
      <div
        *ngIf="alert_message.type"
        class="flex items-center gap-2 rounded-lg p-4 mb-4 text-lg"
        [class]="
          alert_message.type == 'danger'
            ? 'bg-red-100 text-red-700'
            : 'bg-green-100 text-green-700'
        "
      >
        <i
          [class]="
            alert_message.type == 'danger'
              ? 'far fa-times-circle'
              : 'far fa-check-circle'
          "
        ></i>
        <div>
          {{ alert_message.text }}
        </div>
      </div>

      <mat-form-field
        appearance="outline"
        style="width: 100%; font-weight: bold; font-size: 25px"
        class="mx-2"
      >
        <mat-label
          style="
            font-weight: bold;
            font-size: 25px;
            margin-left: 0;
            padding-right: 17px;
          "
          >Nom fournisseur</mat-label
        >
        <input
          type="text"
          matInput
          name="nom_four"
          [(ngModel)]="dsFournisseur.Tiers[0].Tiers_RS"
          placeholder="Nom fournisseur"
        />
      </mat-form-field>
    </div>
  </form>
</ng-template>
